import {Search as PeacockSearch} from '@pepsico-ds/ui'

/** @typedef {import('@pepsico-ds/ui').ISearchProps} SearchProps */

/** Wrapper around Peacock DS Search. @param {SearchProps} props */
export const Search = props => <PeacockSearch {...props} />
